export default {
  breakpoints: [],
  testdefectcount: 0,
  integrations: null,
  summaries: null,
  mappedDataSource: {},
  autoMappedDataSourcesFlag: true,
  backupData: {},
  actionUpdate: {},
  actionChangesCounts: {},
  globalNewTagData: {},
  globalVISData: {},
  globalSmartFixData: {},
  quickSelect: false,
  lastRunJobPath: {},
  mlData: {},
  alertQ: false,
  quickSelectAction: {},
  loadQuick: false,
  useFilteredData: false,
  addActionPassDetail: false,
  actionIdNoML: null,
  quickSelectedElement: null,
  regionSelectChange: false,
  regionSelect: false,
  loadSpinner: false,
  regionSelectAction: {},
  addActionData: {},
  actionsAnamolyStorage: {},
  monacoLocalVariables: [],
  ignoreElementsChange: false,
  selectedRegions: [],
  loadRegionSelect: false,
  ignoreElements: [],
  tabsData: {
    tabs: [
      {
        name: "actions",
        enabled: "Y",
        runtime: "",
        executedts: "",
        executedby: "",
        resourceData: {},
        screenshotsData: {},
        recordedScreenshots: {},
        stepsContext: {},
        consoleAndNetworklog: {},
        extensions: [],
      },
    ],
  },
};
